import { AxiosError } from 'axios';
import { useCallback, useEffect, useState } from 'react'
import { useLocation, useParams } from 'react-router-dom';
import { fetchInvestmentsApi } from '../../apis/investment';
import { getLoanStatusIdFromLoanStatusName, getParameterByName } from '../../helpers';
import history from '../../helpers/history';
import { Loan, LoanStatus } from '../../interfaces';
import { Pagination } from '../../interfaces/common';
import useToggle from '../useToggle';

export const useFetchInvestments = () => {
  // toggle the investment filter modal
  const { show: showForm, toggle: toggleForm } = useToggle();
  const [page, setPage] = useState(1);
  const [pagination, setpagination] = useState<Pagination>()

  // get the investment_types from the url query parameters
  const [investmentTypes, setInvestmentTypes] = useState(getParameterByName("types"));
  const [countrySelection, setCountrySelection] = useState(getParameterByName("countries"));


  const [underwritingInvestments, setUnderwritingInvestments] = useState<Loan[] | null>(null);
  const [activeInvestments, setActiveInvestments] = useState<Loan[] | null>(null);
  const [closedInvestments, setClosedInvestments] = useState<Loan[] | null>(null);

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<Error|null>(null);

  const { menu } = useParams<{ menu: string }>();
  const { pathname } = useLocation<{ pathname: string }>();

  const makeActive = (path: string) => {
    const splitLocation = pathname.split("/");

    if (splitLocation[2]) {
      return splitLocation[2] === path ? "active" : "false";
    }
    return "";
  };

  const updateInvestmentTypeValues = (values: string) => setInvestmentTypes(values);
  const updateCountryValues = (values: string) => setCountrySelection(values);

  const pageQuery = () => {
    let query = `?page=1`;
    if (investmentTypes) {
      query += `&types=${investmentTypes}`;
    }
    if (countrySelection) {
      query += `&countries=${countrySelection}`;
    }
    return query;
  };

  const handleFilterInvestments = () => {
    history.push(`/investments/${menu}${pageQuery()}`);
    fetchInvestments()
    toggleForm();
  };

  const fetchInvestments = useCallback(async () => {
    setLoading(true);
    setError(null)
    try {
      const status = getLoanStatusIdFromLoanStatusName(menu);
      const response = await fetchInvestmentsApi({
        page,
        types: investmentTypes,
        status,
        countries: countrySelection,
      });
      const paginatedInvestments: Pagination = response.data;
      setpagination(paginatedInvestments);
      const investments: Loan[] = paginatedInvestments.data;

      switch (menu) {
        case LoanStatus.UNDERWRITING:
          setUnderwritingInvestments(investments);
          break;
        case LoanStatus.ONGOING:
          setActiveInvestments(investments);
          break;
        default:
          setClosedInvestments(investments);
          break;
      }
      setLoading(false);
    } catch (error) {
      const axiosError = error as AxiosError;
      setError(axiosError);
      setLoading(false);
    }
  }, [countrySelection, investmentTypes, menu, page])


  useEffect(() => {
    if (!menu) {
      history.push("/investments/underwriting?page=1");
    } else {
      fetchInvestments();
    }
  }, [menu, page]);

  return {
    error,
    showForm,
    investmentTypes,
    countrySelection,
    page,
    menu,
    loading,
    underwritingInvestments,
    activeInvestments,
    closedInvestments,
    pagination,
    pageQuery,
    updateInvestmentTypeValues,
    updateCountryValues,
    handleFilterInvestments,
    toggleForm,
    makeActive,
  };
}
